import * as yup from 'yup';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { FAHRERKREIS_TYP } from '@/features/Sparten/shared/types';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import { isOpenFahrerkreis } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { useGlobalStore } from '@/features/Global/store';
import { useInputStore } from '@/features/Sparten';
import { WKZ } from '@/features/Sparten/shared/types/kfz/types';
import { isKradSparte } from '@/features/Sparten/shared/kfz/isKradSparte';

export const isSingleUser = (value: string): boolean =>
  getSimpleChoiceMeta(
    SIMPLE_CHOICE.BEZUG_ZUM_VN_JURISTISCHE_PERSON,
    SIMPLE_CHOICE_META.BEZUG_ZUM_VN_IS_EINZELNUTZER,
  ).includes(value);

export const fahrerkreisSchema = yup.object({
  altersbeschraenkung: yup.boolean().default(true),
  alterJuengsterFahrer: yup
    .number()
    .default(25)
    .when(['altersbeschraenkung', 'typ'], {
      is: (val: boolean, typ: FAHRERKREIS_TYP) => isOpenFahrerkreis(val, typ),
      then: yup.number().test({
        name: 'isCorrect',
        message() {
          if (
            isKradSparte(useGlobalStore().sparte) &&
            useInputStore().allgemein.wkz !== WKZ.KRAFTRAEDER_KRAFTROLLER
          ) {
            return 'Der Wert muss mindestens 16 betragen.';
          }

          return 'Der Wert muss mindestens 18 betragen.';
        },
        test: (value) =>
          value !== undefined &&
          ((isKradSparte(useGlobalStore().sparte) &&
            useInputStore().allgemein.wkz !== WKZ.KRAFTRAEDER_KRAFTROLLER &&
            value >= 16) ||
            value >= 18),
      }),
    }),
  alterAeltesterFahrer: yup
    .number()
    .default(60)
    .when(['altersbeschraenkung', 'typ'], {
      is: (val: boolean, typ: FAHRERKREIS_TYP) => isOpenFahrerkreis(val, typ),
      then: yup.number().min(18),
    }),
  typ: yup.string().default(FAHRERKREIS_TYP.NUR_VN),
  isVnHauptnutzer: yup.boolean().default(true),
  isVnFahrer: yup.boolean().default(true),
});
